import {CrossIcon, IconButton, Modal} from '@logistics-frontend/blocks'
import React from 'react'

import Content from '../../Content'
import * as classes from './ModalDesktop.classes'
import {Props} from './types'

export function ModalDesktop({onClose, contentSections}: Props): React.ReactElement<Props> {
  return (
    <Modal className={classes.root} onClose={onClose} opened>
      <IconButton className={classes.closeButton} onPress={onClose} shape="circle" size="xs" variant="ghost">
        <CrossIcon />
      </IconButton>
      <Modal.Body p={undefined} pb="xs" pt="s">
        <Content sections={contentSections} />
      </Modal.Body>
    </Modal>
  )
}
